import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// 공용 로딩 화면 — 가운데 정렬된 teal 스피너 + 부가 라벨.
// 거창한 스켈레톤 대신 가볍고 일관된 형태로 어디서든 동일한 톤으로 보이게.
//
// 사용 예시:
//   <CommonLoading />                                 // 기본
//   <CommonLoading label="결제 내역 불러오는 중..." /> // 라벨 커스텀
//   <CommonLoading minHeight={300} />                 // 작은 영역(모달 등)에서 사용

const Wrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'minHeightValue',
})(({ minHeightValue }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '14px',
  width: '100%',
  minHeight: typeof minHeightValue === 'number' ? `${minHeightValue}px` : minHeightValue,
}));

const Label = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#94A3B8',
  letterSpacing: '-0.1px',
});

const CommonLoading = ({
  label = '불러오는 중...',
  // 기본값: 페이지 본문 영역 전체를 채워 가운데 정렬 (헤더 + 탭바 + 헤더카드 보정).
  minHeight = 'calc(100vh - 240px)',
  size = 28,
}) => (
  <Wrapper minHeightValue={minHeight}>
    <CircularProgress size={size} thickness={4} sx={{ color: '#4AB3BC' }} />
    {label && <Label>{label}</Label>}
  </Wrapper>
);

export default CommonLoading;
